import { Form } from "antd";
import styles from "./createCompany.module.css";
import { AntdInput, AntdSubmit, InputFielsAntd } from "../../../components";
import minusIcon from "../../../assets/minusIcon.png";
import plusIcon from "../../../assets/plusIcon.png";
import { useEffect, useRef, useState } from "react";
import AlertAction from "../../../store/Actions/AlertActions";
import { useDispatch } from "react-redux";
import CustomerMiddleware from "../../../store/Middlewares/CustomerMiddlewares";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-number-input/input";
import InputField from "../../../components/input/InputField";
import CompanyMiddleware from "../../../store/Middlewares/CompanyMiddleware";
import AutoCompleteAddress from "../../../components/AutoCompleteAddress/AutoCompleteAddress";
const CreateCompany = () => {

    useEffect(() => {
        getLanguage();
    }, []);
    const navigate = useNavigate();

    const dispatch = useDispatch()
    const { t, i18n } = useTranslation();
    const [companyName, setCompanyName] = useState('')
    const [address, setAddress] = useState('')
    const [website, setwebsite] = useState('')
    const [ContactNumber, setContactNumber] = useState('')
    const getLanguage = async () => {
        try {
            const language = localStorage.getItem('@selectedLanguage');
            i18n.changeLanguage(language);
        } catch (e) {
            console.log(e);
        }
    };

    const onPressCreateCompany = () => {
        const urlRegex = /(^https?|^http):\/\/www\.?[a-zA-Z0-9.-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?$/i;
        if (!companyName || !address || !ContactNumber) {
            dispatch(AlertAction.ShowAlert({ type: "warning", message: 'All Field Required' }))
        }
        else if (website) {
            if (urlRegex.test(website) == true) {
                newCompanyData()
            }
            else {
                dispatch(AlertAction.ShowAlert({ type: "error", message: 'Invalid website url!' }))
            }
        }
        else {
            newCompanyData()
        }
    }

    const newCompanyData = () => {
        let payload = {
            CompanyName: companyName,
            CompanyContact: ContactNumber,
            CompanyLat: address.lat,
            CompanyLng: address.lng,
            CompanyAddress: address.address,
            CompanySite: website.toLowerCase(),
        }
        dispatch(CompanyMiddleware.createCompany(payload)).then(data => {
            if (data.success) {
                navigate(-1)
            }
        })
    }

    const onSelectLocation = (place) => {
        let currentLocation = {
          lat: place?.geometry?.location?.lat(),
          lng: place?.geometry?.location?.lng(),
          address: place?.formatted_address
        }
        setAddress(currentLocation)
      }


    return (
        <div className={styles.mainCon}>
            <h1>{t("Create New Company")}</h1>
            <div className={styles.row}>
                <div className={styles.col}>
                    <InputField
                        label={t("Company Name")}
                        placeholder={t("Company Name")}
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        width='100%'
                    />
                </div>
                <div className={styles.col}>
                    {/* <InputField
                        label={t("Address")}
                        placeholder={t("Address")}
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        width='100%'
                    /> */}
                    <AutoCompleteAddress label={'Address'} onSelectLocation={onSelectLocation} />

                </div>
            </div>
            <div className={styles.row}>
                <div className={styles.col}>
                    <div className={styles.phoneInput}>
                        <label>{t("Contact Number")}</label>
                        <PhoneInput
                            className={styles.PhoneNumber}
                            placeholder={"Contact Number"}
                            defaultCountry="US"
                            value={ContactNumber}
                            maxLength={16}
                            onChange={setContactNumber}
                        />
                    </div>
                </div>
                <div className={styles.col}>
                    <InputField
                        label={t("Website Link")}
                        placeholder={"https://www.website.com"}
                        value={website}
                        onChange={(e) => setwebsite(e.target.value)}
                        width='100%'
                    />
                </div>
            </div>

            <div className={styles.row}>
                <div className={styles.col}>
                    <AntdSubmit
                        text={t("Add Company")}
                        buttonStyle={{
                            margin: "30px 0px",
                            height: "60px",
                            width: "100%",
                        }}
                        onClick={onPressCreateCompany}
                    />
                </div>
                <div className={styles.col}></div>
            </div>
            {/* </Form> */}
        </div>
    );
};

export default CreateCompany